(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('agreementPatientAcknowledgementComponent', agreementPatientAcknowledgementComponent);

    agreementPatientAcknowledgementComponent.$inject = [];

    function agreementPatientAcknowledgementComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectiveAgreementPatientAcknowledgementController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/agreement-patient-acknowledgement.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveAgreementPatientAcknowledgementController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectiveAgreementPatientAcknowledgementController($scope, $stateParams, $element) {
        var vm = this;
        vm.onChangeSignature = onChangeSignature;

        function init() {
        	if (vm.workflow.answer.agreement) {
                if (vm.workflow.answer.agreement.dateSigned === null || vm.workflow.answer.agreement.dateSigned === undefined) {
                    vm.workflow.answer.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        init();
        
        function onChangeSignature(data) {
            vm.workflow.answer.agreement.patientSignature = data;
        }
    }
})();
